import { UserService } from './../../../services/user.service';
import {Component, HostListener, OnInit} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {EmailValidators} from '../../../validators/emailValidators';


@Component({
  selector: 'app-business-user-signup',
  templateUrl: './business-user-signup.component.html',
  styleUrls: ['./business-user-signup.component.css']
})
export class BusinessUserSignupComponent implements OnInit {

  countryCode = ['us'];
  inProgress = false;
  isFormSubmitted = false;
  form: FormGroup;
  // Wizard Step
  currentStep = 1;
  // Wizard Tabs
  tabs: Array<any> = [
    { step: 1, image: 'assets/img/signup/st1.png', title: 'Create Account' },
    { step: 2, image: 'assets/img/signup/st2.png', title: 'Confirm' }
  ];
  errorMessage: any;
  resellerCompany;
  resellerPhone;
  private role: string;

  constructor(private fb: FormBuilder, private userService: UserService) {
    this.role = 'ROLE_USER';
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      firstName: ['', Validators.compose([
        Validators.required,
      ])],
      addressLine1: ['', Validators.compose([
        Validators.required,
      ])],
      city: ['', Validators.compose([
        Validators.required,
      ])],
      state: ['', Validators.compose([
        Validators.required,
      ])],
      zip: ['', Validators.compose([
        Validators.required,
      ])],
      country: ['', Validators.compose([
        Validators.required,
      ])],
      lastName: ['', Validators.compose([
        Validators.required,
      ])],
      phoneNumber: ['', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(15)
      ])],
      skypeId: [''],
      username: ['', Validators.compose([
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(50)
      ])],
      email: ['', Validators.compose([
        Validators.required,
        EmailValidators.invalidEmail
      ])],
      password: ['', Validators.compose([
        Validators.required
      ])],
      confirmPassword: ['', Validators.compose([
        Validators.required
      ])],
      howFindUs: [''],
      companyName: ['', Validators.compose([
        Validators.required
      ])]
    });

  }

  nextStep() {
    this.isFormSubmitted = true;
    if (!this.form.valid) {
      alert('Please resolve all the issues before continuing to next step.');
      return;
    }
    if (this.inProgress) {
      return;
    }
    this.errorMessage = null;
    this.inProgress = true;
    const data = this.form.value;
    data.address = {
      addressLine1: this.form.value.addressLine1,
      city: this.form.value.city, state: this.form.value.state,
      zip: this.form.value.zip, country: this.form.value.country
    };
    this.userService.signUp(data, this.role, false)
      .finally(() => {
        this.inProgress = false;
      })
      .subscribe(response => {
          this.resellerCompany = response.resellerCompany;
          this.resellerPhone = response.resellerPhone;
          if (this.currentStep < this.tabs.length){
            this.currentStep = 2;
          }
          window.scrollTo(0, 0);
        },
        error => {
          const errorBody = JSON.parse(error._body);
          this.errorMessage = errorBody.message;
        });

  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    this.userService.sendPartialSignUpDataToServer(this.form.value, this.role, true);
  }

  abortSignUp() {
    this.userService.sendPartialSignUpDataToServer(this.form.value, this.role);
    return false;
  }

  autoFillResellerCompany() {
    this.userService.getDataFromIPGeo()
      .then((res: any) => {
          this.form.get('country').setValue(res.country_name);
          this.form.get('city').setValue(res.city);
          this.form.get('state').setValue(res.state_prov);
          this.form.get('zip').setValue(res.zipcode);
          // this.form.get('address.phoneNumber').setValue(res.country_code2.toLowerCase());
          this.countryCode = [res.country_code2.toLowerCase()];

        },
        error => {
          console.log('Error' + error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/sign-up/business-user-signup/business-user-signup.component.ts